<template>
  <div :class="$style.loanOffer">
    <b :class="$style.offerDetails">Offer Details </b>
    <div :class="$style.offerOverflow">
      <div :class="$style.advertiserDisclosureParent">
        <b :class="$style.advertiserDisclosure">Advertiser Disclosure</b>
        <div :class="$style.bgFmsParent">
          <img
            :class="$style.bgFmsIcon"
            alt=""
            src="/static/img/fmsbanklogo.png"
          />
          <img :class="$style.frameChild" alt="" src="/static/img/heart2.svg" />
        </div>
      </div>
      <div :class="$style.loanOfferInner">
        <div :class="$style.frameParent">
          <div :class="$style.ratesParent">
            <div :class="$style.rates">
              <div :class="$style.rightParent">
                <div :class="$style.length">Length*</div>
                <div :class="$style.label">120 mo</div>
              </div>
              <div :class="$style.rightParent">
                <div :class="$style.length">Monthly Payment</div>
                <div :class="$style.label">$1,565.65/mo</div>
              </div>
            </div>
            <div :class="$style.rates">
              <div :class="$style.leftParent">
                <div :class="$style.length">APR Est.*</div>
                <div :class="$style.label">11.58%</div>
              </div>
              <div :class="$style.leftParent">
                <div :class="$style.length">Loan Amount</div>
                <div :class="$style.label">$110,997</div>
              </div>
            </div>
          </div>
          <div :class="$style.ratesParent">
            <div :class="$style.rates">
              <div :class="$style.rightParent">
                <div :class="$style.length">Interest & Fees Est.*</div>
                <div :class="$style.label">$79,881.20</div>
              </div>
            </div>
            <div :class="$style.rates">
              <div :class="$style.leftParent">
                <div :class="$style.length">Total Paid (120/mo)</div>
                <div :class="$style.principalInterest">
                  $193,378.20 (Principal + Interest + Fees)
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="$style.frameGroup">
        <div :class="$style.groupParent">
          <img :class="$style.frameItem" alt="" src="/static/img/badge.svg" />
          <div :class="$style.advertiserDisclosure">
            <p :class="$style.description">
              <b :class="$style.benefitsOrFeatures">Benefits or Features:</b>
              <span> No prepayment penalty, flexible terms, </span>
            </p>
            <p :class="$style.description">
              low fixed rates, 12-month deferral
            </p>
          </div>
        </div>
        <img :class="$style.frameInner" alt="" src="/static/img/info.svg" />
      </div>
      <div :class="$style.loanOfferChild">
        <div :class="$style.offerDetailsParent">
          <b :class="$style.offerDetails1">Offer Details</b>
          <div :class="$style.rectangleParent">
            <div :class="$style.rectangleDiv" />
            <div :class="$style.advertiserDisclosure">
              APRs from 8.91% to 25.99% and loan amounts from $1000 to $110,997.
            </div>
          </div>
          <div :class="$style.rectangleParent">
            <div :class="$style.rectangleDiv" />
            <div :class="$style.advertiserDisclosure">
              Origination Fee: $2,500 (This fee is added to the loan balance at
              funding).
            </div>
          </div>
          <div :class="$style.rectangleContainer">
            <div :class="$style.rectangleDiv" />
            <div :class="$style.advertiserDisclosure">
              Deferment Period: 12 months before repayment begins.
            </div>
          </div>
          <div :class="$style.rectangleParent">
            <div :class="$style.rectangleDiv" />
            <div :class="$style.advertiserDisclosure">
              <p :class="$style.description">
                Easy application Process: Simple and online application and
                access to live customer
              </p>
              <p :class="$style.description">
                support 7 days a weeks.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div :class="$style.loanOfferOuter">
        <div :class="$style.offerDetailsParent">
          <b :class="$style.offerTerms">Offer terms & conditions</b>
          <div :class="$style.checkingARateContainer">
            <p :class="$style.description">
              Checking a rate generates a soft credit inquiry, visible only to
              the applicant and does not impact credit scores. A hard credit
              inquiry, which may affect credit scores, will only occur if and
              when a loan is issued. Credit eligibility is not guaranteed.
              Terms, including APR and loan conditions, are subject to the
              applicant's credit score and financial profile, including loan
              amount, term length, and credit history.
            </p>
            <p :class="$style.description">&nbsp;</p>
            <p :class="$style.description">
              A representative example of payment terms: A borrower receives a
              loan of $20,000 with a 12.00% interest rate and a 3.00%
              origination fee added to the loan amount for a 36-month term. The
              borrower would repay a total loan amount of $20,600 (including the
              origination fee) and make 36 monthly payments of approximately
              $684, starting after a 12-month deferment period. Loan amounts
              range from $1,000 to $120,000 with terms between 12 and 120
              months. Actual amounts, rates, and terms may vary based on
              location and availability.
            </p>
            <p :class="$style.description">&nbsp;</p>
            <p :class="$style.description">
              APR ranges from 9.00% to 23.00%, with origination fees ranging
              from 1.00% to 5.00%, depending on creditworthiness. Lowest APRs
              are available to borrowers with excellent credit. Rates, fees, and
              terms are subject to change and are determined at the time of
              application.
            </p>
            <p :class="$style.description">&nbsp;</p>
            <p :class="$style.description">
              Loans are subject to credit approval and investor commitment.
              Membership with certain institutions may be required, depending on
              the lender. Information such as income, loan amount, purpose, and
              qualifying debt will be used to determine eligibility. Loan
              closing requires acceptance of all agreements and disclosures.
              Additionally, borrowers may take advantage of a 12-month deferment
              period before beginning repayment, allowing flexibility during the
              initial term.
            </p>
          </div>
        </div>
      </div>
      <div :class="$style.takeOfferWrapper">
        <b :class="$style.takeOffer">Take Offer</b>
      </div>
      <img
        :class="$style.vectorIcon"
        alt=""
        src="/static/img/grey-x.svg"
        @click="closeModal"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
});
</script>

<style module scoped>
.offerOverflow {
  overflow-y: auto;
}
.offerDetails {
  position: relative;
  font-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 0;
  height: 50px;
}
.advertiserDisclosure {
  position: relative;
}
.bgFmsIcon {
  width: 130px;
  position: relative;
  height: 56.1px;
  object-fit: cover;
}
.frameChild {
  width: 20px;
  position: relative;
  height: 20px;
}
.bgFmsParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px 0 0;
  gap: 0;
  margin-bottom: 30px;
}
.advertiserDisclosureParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 30px;
  z-index: 1;
  color: #04a544;
}
.length {
  position: relative;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
}
.label {
  position: relative;
  color: #404040;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
}
.rightParent {
  align-self: stretch;
  border-top: 1px solid #dcdcdc;
  border-right: 0.5px solid #dcdcdc;
  border-bottom: 0.5px solid #dcdcdc;
  box-sizing: border-box;
  height: 70px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 5px 10px;
  gap: 10px;
}
.leftParent {
  align-self: stretch;
  border-top: 0.5px solid #dcdcdc;
  border-left: 0.5px solid #dcdcdc;
  border-bottom: 0.5px solid #dcdcdc;
  box-sizing: border-box;
  height: 70px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 5px 10px;
  gap: 10px;
}
.rates {
  width: 300px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.ratesParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.principalInterest {
  position: relative;
  color: #404040;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.frameParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.loanOfferInner {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  z-index: 2;
  color: #8b8b8b;
  margin-bottom: 30px;
}
.frameItem {
  width: 30px;
  position: relative;
  height: 30px;
}
.benefitsOrFeatures {
  font-family: Helvetica, Arial, sans-serif;
  font-size: 16px;
}
.description {
  margin: 0;
  font-size: 16px;
}
.groupParent {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
}
.frameInner {
  width: 25px;
  position: relative;
  height: 25px;
}
.frameGroup {
  align-self: stretch;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px 0 0;
  gap: 0;
  z-index: 3;
  font-size: 16px;
  color: #000;
  margin-bottom: 30px;
}
.offerDetails1 {
  width: 160px;
  position: relative;
  font-size: 18px;
  display: inline-block;
  color: #404040;
}
.rectangleDiv {
  width: 10px;
  position: relative;
  background-color: #038d2f;
  height: 10px;
}
.rectangleParent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}
.rectangleContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  font-size: 17px;
}
.offerDetailsParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
}
.loanOfferChild {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  z-index: 4;
  font-size: 16px;
  color: #000;
}
.offerTerms {
  align-self: stretch;
  position: relative;
}
.checkingARateContainer {
  align-self: stretch;
  position: relative;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
}
.loanOfferOuter {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  z-index: 6;
  font-size: 18px;
}
.takeOffer {
  position: relative;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.takeOfferWrapper {
  align-self: stretch;
  border-radius: 5px;
  background-color: #3171e2;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  z-index: 7;
  text-align: center;
  font-size: 18px;
  color: #fff;
}
.vectorIcon {
  width: 12px;
  position: absolute;
  margin: 0 !important;
  top: 39px;
  right: 51px;
  height: 12px;
  z-index: 8;
  cursor: pointer;
}
.loanOffer {
  width: 700px;
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px;
  box-sizing: border-box;
  gap: 30px;
  text-align: left;
  font-size: 15px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
  height: 900px;
}
</style>
